import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetTrackerLastUpdateRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetTrackerLastUpdate`
});

export const GetTrackerTableRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/GetTracker`
});

export const SyncTrackerRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/TrackerUpload`
});

export const DownloadTrackerRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/DownloadTracker`
});

export const ImportTrackerRequest = (filePath) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Tracker/ImportTracker`,
	params: { filePath }
});
